import React from 'react';

const Products = props => {

  return (
    <section className="product-benefits">
      <div className="product-benefits-group">
        <div className="product-benefit-1-tagline">
          <h3>Primetrics</h3>
          <p>Piattaforma di analisi dei dati di vendita</p>
        </div>
        <div className="product-benefit-1-image"></div>
        <div className="product-benefit-2-tagline">
          <h3>E-console</h3>
          <p>
            Gestionale cloud.<br/>Intuitivo, multipiattaforma e sicuro
          </p>
        </div>
        <div className="product-benefit-2-image"></div>
      </div>
    </section>
  )
};

export default Products;
